import React from 'react';

export default (props) => {
  let className = 'row ';
  if (props.className) {
    className += props.className;
  }
  return (
    <div {...props} className={className.trim()}>
      {props.children}
    </div>
  );
}



/** WEBPACK FOOTER **
 ** ./components/grid.js
 **/